<template>
  <div id="app">
    <router-view
      :cart="cart"
      :auth="auth"
      :slimFooter="slimFooter"
      :connected="connected"
      :langKeys="langKeys[actualLng]"
      :images="images"
      :showLoader="showLoader"
      :setUserInfos="setUserInfos"
      :hideLoader="hideLoader"
      :setToken="setToken"
      :isToken="isToken"
      :activatePopupLogin="activatePopupLogin"
      :activatePopupMessage="activatePopupMessage"
      :setActualLng="setActualLng"
      :lngSwitch="lngSwitch"
      :setSwitch="setSwitch"
      :getHomeFilters="getHomeFilters"
      :newUser="newUser"
      :userEmail="userEmail"
      :getImages="getImages"
      :checkDomainName="checkDomainName"
      :domainAvailable="domainAvailable"
      :emailExist="emailExist"
      :websiteNameExist="websiteNameExist"
      :getWebsitesList="getWebsitesList"
      :getDomainList="getDomainList"
      :closePopupNewWebsiteFromDomain="closePopupNewWebsiteFromDomain"
      :isPopupCreateWebsiteFromDomain="isPopupCreateWebsiteFromDomain"
      :activeCreateWebsiteFromDomain="activeCreateWebsiteFromDomain"
      :catalogDomainCreate="catalogDomainCreate"
      :listALlMailbox="listALlMailbox"
      :getClientToken="getClientToken"
      :enToFr="enToFr"
      :enToSp="enToSp"
      :enToLng="enToLng"
      :isTranslable="isTranslable"
      :getAll="getAll"
      :languages="languages"
      :languagesCodes="languagesCodes"
      :logout="logout"/>
  </div>
</template>


<style lang="scss">
.domain-list {
  &__domain {
    width: 100%;
    max-width: 800px;
    display: inline-block;
    background: #2a2a2a;
    padding: 8px 0 8px 8px;
    color: #fff;
    margin-bottom: -6px;
    &:hover {
      background: #0d0d0d;
    }
    &__name {
      float: left;
      color: #fff;
      width: 200px;
    }
    &__status {
      float: left;
      color: #fff;
      width: calc(100% - 390px);
    }
    &__price {
      float: left;
      color: #fff;
      width: 90px;
      min-height: 1px;
      text-align: right;
    }
    &__buy {
      float: left;
      color: #fff;
      width: 100px;
      position: relative;
      .loader {
        position: absolute;
        top: 3px;
        right: 0;
      }
      button {
        position: absolute;
        top: -5px;
        left: 4px;
        padding: 7.5px 15px;
        margin-left: 15px;
      }
    }
  }
}
</style>

<style lang="scss">
@import "../node_modules/@mdi/font/css/materialdesignicons.min.css";
@import "../node_modules/flag-icon-css/css/flag-icon.min.css";
@import "./assets/scss/style";
</style>

<script>
// COMPONENTS
import langKeys from '@/languagesKeys/all.js'
// import footerApp from '@/views/component/Footer.vue'
// import headerApp from '@/views/component/Header.vue'

// API
import api from '@/api/index.js'
export default {
  name: 'App',
  props: { },
  components: {
    // footerApp, headerApp
  },
  data () {
    return {
      getSitemap: {} || [],
      cart: [
        { item: "Domain", description: "mydomainname.com",Quantity: '1', Price: 23.23 },
        { item: "Website", description: "website hosting, wordpress cms, 1 year",Quantity: '1', Price: 120 },
      ],
      jwt_token: false,
      // apiUrl: 'http://localhost:3000/',
      apiUrl: 'https://api.prismyk.com/',
      domainAvailable: [] || {},
      userEmail: '',
      connected: false,
      userInfos: {},
      isPopupLogin: false,
      isPopupSignUp: false,
      isPopupCreateWebsiteFromDomain: false,
      userToken: '',
      loginMessage: '',
      SignUpMessage: '',
      actualLng: 'fr',
      hasFooter: 'normal',
      isLoading: false,
      isPopupMessage: false,
      messageToSeller: '',
      messageCarId: '',
      messageCar: {},
      lngSwitch: {},
      images: {},
      langKeys,
      emailExist: null,
      websiteNameExist: null
    }
  },
  computed: {
    isToken () {
      return this.userToken !== ''
    }
  },
  watch: {
    $route (to, from) {
      window.scrollTo(0, 0)
      // if(to.name !== "login" && to.name !== "register" && !this.isToken)
      // this.$router.push({ name: "login" })
    }
  },
  methods: {
    async getAll (lng) {
      return await api.sitemap.getAll(lng)
    },
    async languages (word) {
      return await api.translate.languages(word)
    },
    async languagesCodes (word) {
      return await api.translate.languagesCodes(word)
    },
    async isTranslable (word, lng) {
      return await api.translate.isTranslable(word,lng)
    },
    async enToLng (word, lng) {
      return await api.translate.enToLng(word,lng)
    },
    async enToFr (word) {
      return await api.translate.enToFr(word)
    },
    async enToSp (word) {
      return await api.translate.enToSp(word)
    },
    async getClientToken () {
      return await api.paypal.getClientToken()
    },
    async listALlMailbox () {
      const list = await api.mailbox.listAll()
      return list
    },
    async getWebsitesList () {
      const list = await api.website.getWebsitesList()
      return list
    },
    async getDomainList () {
      const list = await api.domain.list()
      return list
    },
    async auth (form) {
      this.showLoader()
      const response = await api.auth.login({
        email: form.email,
        pw: form.pw,
        stay: form.stay
      })
      if (response.logged === true) {
        this.setToken(response.token)
        this.setUserInfos(response.user)
        this.connected = true
        this.didNotLogged = false
        this.$router.push({ name: 'dashboard' })
      } if (response.logged === false) {

        return false
      } else {

        return false
      }
      this.hideLoader()
    },
    async newUser (form) {
      this.showLoader()
      this.axios.defaults.headers.common = {}
      this.axios.defaults.headers.common.accept = 'application/json'
      const options = {
        url: this.apiUrl + 'apiNewUser',
        method: 'POST',
        timeout: 0,
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          email: form.email,
          websiteName: form.websiteName,
          pw: form.pw,
          sector: form.sector,
          checked: form.userAgreement,
          createWebsite: form.createWebsite,
          isCreator: form.creator,
          newsLetter: form.newsLetter,
          emailExist: false
        }
      }
      return await this.axios(options)
        .then(response => {
          this.hideLoader()
          if (response.data.logged === true) {
            this.setToken(response.data.token)
            this.setUserInfos(response.data.user)
            this.emailExist = null
            this.websiteNameExist = null
            this.$router.push({ name: "dashboard" })
          } else if (response.data.emailExist || response.data.websiteNameExist) {
            return response.data
          }
        })
    },
    async checkDomainName (name) {
      return await api.domain.domainAvailable(name)
    },
    async catalogDomainCreate () {
      const response = await api.domain.catalogDomainCreate()
      return response
    },
    slimFooter () {
      this.hasFooter = 'slim'
    },
    setSwitch (lngSwitch) {
      this.lngSwitch = lngSwitch
    },
    setActualLng (lng) {
      this.actualLng = lng
    },
    activatePopupLogin (message = '', callBack = false) {
      this.isPopupLogin = true
      this.loginMessage = message
      if (callBack) {
        alert(callBack)
      }
    },
    activatePopupSignUp (message = '', callBack = false) {
      this.isPopupSignUp = true
      this.SignUpMessage = message
      if (callBack) {
        alert(callBack)
      }
    },
    activeCreateWebsiteFromDomain (domainName) {
      this.isPopupCreateWebsiteFromDomain = true
      return domainName
    },
    activatePopupMessage (id, message = '', car = '') {
      this.isPopupMessage = true
      this.messageToSeller = message
      this.messageCarId = id
      this.messageCar = car
    },
    closePopupLogin () {
      this.isPopupLogin = false
    },
    closePopupNewWebsiteFromDomain () {
      this.isPopupCreateWebsiteFromDomain = false
    },
    closePopupSignUp () {
      this.isPopupSignUp = false
    },
    closePopupMessage () {
      this.isPopupMessage = false
    },
    logout () {
      this.connected = false
      this.userToken = ''
      this.userInfos = ''
      this.isPopupLogin = false
      this.$cookies.remove('user')
      this.userToken = ''
      this.$router.push({ name: 'login' })
      this.$forceUpdate()
    },
    setToken (token) {
      this.$cookies.set('user', token)
      this.userToken = token
    },
    checkToken (token) {
      const tmpToken = window.$cookies.get('user')
      // Todoo : api check token
      this.userToken = tmpToken !== null ? tmpToken : ''
      this.connected = tmpToken !== null
    },
    setUserInfos (userInfos) {
      this.userInfos = userInfos
    },
    showLoader () {
      this.isLoading = true
    },
    hideLoader () {
      this.isLoading = false
    },
    sendMessage (message, carId) {
      var options = {
        url: this.apiUrl + 'sendMessage',
        method: 'post',
        timeout: 0,
        headers: {
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({
          message,
          carId
        })
      }
      this.axios(options)
          .then(response => {
            console.log(response.data)
          })
    },
    async getHomeFilters (data) {
      const test = await this.apiRequest2('getHomeFilters', 'post', data)
      return test
    },
    // async apiRequest2 (methodName, method, data) {
    //   var options = {
    //     url: 'http://localhost:3000/' + methodName,
    //     method: method,
    //     timeout: 0,
    //     headers: {
    //       'Content-Type': 'application/json'
    //     },
    //     data: data
    //   }
    //   return this.axios(options)
    //     .then(response => {
    //       return response.data
    //     })
    // },
    getImages (q) {
      var options = {
        method: 'GET',
        url: 'https://pixabay.com/api/?key=472900-f87b8a7c3200f87e3bab266bd&q=' + q + '&lang=fr&image_type=photo&page=1&per_page=200'
      }
      this.axios(options)
          .then(response => {
            console.log(response.data)
            this.images = response.data
          })
    },
    async apiRequest2 (methodName, method, params) {
      // this.showLoader()
      const headers = {
        'Content-Type': 'application/json'
      }
      if (this.jwt_token) {
        headers.Authotization = 'Bearer ' + this.jwt_token
      }
      const options = {
        url: this.apiUrl + methodName + '/?' + params,
        method: method,
        timeout: 0,
        headers,
        data: JSON.stringify({})
      }
      return this.axios(options)
          .then(response => {
            return response.data
          })
    },
    apiRequest (methodName, method) {
      // this.showLoader()
      const options = {
        url: this.apiUrl + methodName,
        method: method,
        timeout: 0,
        headers: {
          'Content-Type': 'application/json'
        },
        data: JSON.stringify({})
      }
      this.axios(options)
          .then(response => {
            switch (methodName) {
              case 'getPanneaux':
                this.panneauxNear = response.data
                break

              case 'getTRC':
                this.tcrNear = response.data
                break

              case 'getUserSettings':
                this.userSettings = response.data
                break

              case 'setUserSettings':
                this.userSettings = response.data
                break

              case 'login':
                this.userSettings = response.data
                break
            }
            // this.hideLoader()
            this.newMapData = 1
          })
    }
  },
  mounted: async function () {
    this.checkToken()
  }
}
</script>
